import { z } from 'zod'
import { AssignArticle } from '@/modules/sales/clients/types/Article.ts'
import { productTypeNameSchema } from '@/modules/sales/clients/types/articleTypes/Common.ts'

export const getArticleTypeTxt = (
  articleType: AssignArticle['productType']
): z.infer<typeof productTypeNameSchema> => {
  switch (articleType) {
    case 1:
      return 'Teléfono'
    case 2:
      return 'Laptop'
    case 3:
      return 'Apple'
    case 4:
      return 'Otros'
    case 6:
      return 'Motor'
    case 7:
      return 'Miscelánea'
    default:
      throw new Error(
        `Article type '${articleType}' does not exist in the possible article types`
      )
  }
}

export const articleTypes = {
  phone: 1,
  laptop: 2,
  apple: 3,
  others: 4,
  rechargeService: 5,
  motor: 6,
  miscellaneous: 7
} as const
